import { supabase } from "../supabase/client";

export const projectService = {
    async getProjects() {
        const { data, error } = await supabase
            .from("projects")
            .select("*")
            .order("created_at", { ascending: true });

        if (error) throw error;
        return data || [];
    },

    async createProject(projectData, userId) {
        const newProject = {
            ...projectData,
            user_id: userId
        };

        const { data, error } = await supabase
            .from("projects")
            .insert([newProject])
            .select();

        if (error) throw error;
        return data ? data[0] : null;
    },

    async updateProject(id, updatedFields, userId) {
        const { data, error } = await supabase
            .from("projects")
            .update(updatedFields)
            .eq("user_id", userId)
            .eq("id", id)
            .select();

        if (error) throw error;
        return data && data.length > 0 ? data[0] : null;
    },

    async deleteProject(id, userId) {
        // 1. Eliminar tareas asociadas a este proyecto
        const { error: tasksError } = await supabase
            .from("tasks")
            .delete()
            .eq("user_id", userId)
            .eq("project_id", id);

        if (tasksError) throw tasksError;

        // 2. Eliminar el proyecto
        const { data, error } = await supabase
            .from("projects")
            .delete()
            .eq("user_id", userId)
            .eq("id", id)
            .select();

        if (error) throw error;
        return data;
    },

    async seedInitialData(userId, projectName = "🎯 Mi Primer Proyecto") {
        const todayStr = new Date().toISOString().split("T")[0];

        // 1. Crear proyecto inicial de ejemplo
        const { data: projData, error: projError } = await supabase
            .from("projects")
            .insert([{
                name: projectName,
                icon: "🎯",
                color: "#3b82f6",
                user_id: userId
            }])
            .select();

        if (projError) {
            console.error("Error al crear proyecto inicial:", projError);
            throw projError;
        }

        const createdProject = projData && projData.length > 0 ? projData[0] : null;
        if (!createdProject) return null;

        // 2. Crear tareas de ejemplo con tipos de datos correctos (priority numérico)
        const sampleTasks = [
            {
                name: "👋 ¡Bienvenido a tu gestor de tareas!",
                description: "Haz clic en la casilla de la izquierda para marcarla como completada o mantenla presionada en móvil.",
                project_id: null,
                priority: 1,
                due_date: todayStr,
                due_time: "09:00",
                is_recurring: false,
                recurrence_type: null,
                recurrence_days: null,
                reminder_type: "none",
                reminder_date: null,
                done: false,
                user_id: userId
            },
            {
                name: "🎯 Tarea de ejemplo en tu proyecto",
                description: "Esta tarea pertenece al proyecto '🎯 Mi Primer Proyecto'. Puedes editarla o completarla.",
                project_id: createdProject.id,
                priority: 2,
                due_date: todayStr,
                due_time: "12:00",
                is_recurring: false,
                recurrence_type: null,
                recurrence_days: null,
                reminder_type: "none",
                reminder_date: null,
                done: false,
                user_id: userId
            },
            {
                name: "📝 Planificar próximos objetivos",
                description: "Organiza tu trabajo agregando más tareas con fechas y prioridades a tus proyectos.",
                project_id: createdProject.id,
                priority: 3,
                due_date: todayStr,
                due_time: "17:00",
                is_recurring: false,
                recurrence_type: null,
                recurrence_days: null,
                reminder_type: "none",
                reminder_date: null,
                done: false,
                user_id: userId
            }
        ];

        const { data: tasksData, error: tasksError } = await supabase
            .from("tasks")
            .insert(sampleTasks)
            .select();

        if (tasksError) {
            console.error("Error al crear tareas iniciales de ejemplo:", tasksError);
        }

        return { project: createdProject, tasks: tasksData || [] };
    }
};
